var map = {
	"./artwork_bloom.jpg": 772,
	"./artwork_craving.jpg": 927,
	"./artwork_fragile.jpg": 765,
	"./artwork_larva.jpg": 239,
	"./artwork_windspieli.jpg": 444,
	"./cover_bloom.jpg": 110,
	"./cover_demo.jpg": 566,
	"./music": 867,
	"./music.json": 867,
	"./vubg01.jpg": 163,
	"./vubg02.jpg": 306,
	"./vubg03.jpg": 25,
	"./vucard.png": 999,
	"./vulogo.png": 512,
	"./vupic.jpg": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;